import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RateManager from './rate-manager';
import ActivityTreePage from './activity-tree';

const RateEngineRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="rate-manager" element={<RateManager />} />
      <Route path="activity-tree" element={<ActivityTreePage />} />
      <Route index element={null} />
    </Routes>
  );
};

export default RateEngineRoutes;
